import { useTranslation } from "react-i18next";
import { IRouteItem } from "../../../../../types";
import { osloDateTimeInput } from "../../../../../helpers/planningDateTime";

type Props = { stop: IRouteItem; onChange: (stop: IRouteItem) => void };

/** Explicit integration deadlines must be visible/editable, not hidden behind
 * legacy clock selectors which would otherwise change an ignored value. */
export const StopTimeWindowsEditor = ({ stop, onChange }: Props) => {
  const { t } = useTranslation("orders");
  return (
    <section className="mb-3 space-y-3 rounded border border-border p-3">
      <p className="text-xs text-secondary">{t("planning_windows.hint")}</p>
      {(["requiredTimeWindows", "preferredTimeWindows"] as const).map(
        (field) => {
          const windows = stop[field] ?? [];
          return (
            <div key={field} className="space-y-2">
              <p className="text-sm font-medium">
                {t(`planning_windows.${field}`)}
              </p>
              {!windows.length ? (
                <p className="text-xs text-secondary">
                  {t("planning_windows.none")}
                </p>
              ) : null}
              {windows.map((window, index) => (
                <div key={index} className="flex flex-wrap gap-2">
                  {(["startAt", "endAt"] as const).map((edge) => (
                    <input
                      key={edge}
                      type="datetime-local"
                      aria-label={`${t(`planning_windows.${field}`)} ${t(`planning_windows.${edge}`)} ${index + 1}`}
                      value={osloDateTimeInput(window[edge])}
                      onChange={(event) =>
                        onChange({
                          ...stop,
                          [field]: windows.map((item, itemIndex) =>
                            itemIndex === index
                              ? { ...item, [edge]: event.target.value }
                              : item,
                          ),
                        })
                      }
                      className="min-w-0 rounded border border-border bg-surface p-2 text-sm text-text"
                    />
                  ))}
                  <button
                    type="button"
                    className="text-xs text-danger"
                    onClick={() =>
                      onChange({
                        ...stop,
                        [field]: windows.filter(
                          (_, itemIndex) => itemIndex !== index,
                        ),
                      })
                    }
                  >
                    {t("planning_windows.remove")}
                  </button>
                </div>
              ))}
              {windows.length < 20 ? (
                <button
                  type="button"
                  className="text-xs text-brand"
                  onClick={() =>
                    onChange({
                      ...stop,
                      [field]: [...windows, { startAt: "", endAt: "" }],
                    })
                  }
                >
                  {t("planning_windows.add")}
                </button>
              ) : null}
            </div>
          );
        },
      )}
    </section>
  );
};
